module.exports = __webpack_public_path__ + "static/img/printed-img-01@w.85d3836.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/genesis-shop/printed-img-01@w.png
// module id = TpVq
// module chunks = 0